import SliderVerify from 'slider-verify-v2'
import 'slider-verify-v2/lib/SliderVerify.css'
import Vue from "vue";
Vue.use(SliderVerify)
